import { render, staticRenderFns } from "./ManageRegistrationForm.vue?vue&type=template&id=079f582a&"
import script from "./ManageRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./ManageRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports